export default __webpack_public_path__ + "static/media/redux.010fcccb.png";